var _style, _switch;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowClickedUnfold(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ArrowRolloverUnfold",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50.5 50.5",
    style: {
      enableBackground: "new 0 0 50.5 50.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.996;}\n\t.st1{fill:#FB8861;}\n\t.st2{fill:#FDBB63;}\n\t.st3{enable-background:new    ;}\n\t.st4{fill:#1D1D1B;}\n")), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M39.2,20.7L28.1,9.6l-1.3-1.9L26.2,8l0.2,2.3v37.8h-3.3V10.3L23.3,8l-0.6-0.2l-1.3,1.9L10.3,20.7L8,18.4 L23.4,2.9H26l15.5,15.5L39.2,20.7z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowClickedUnfold);
export default __webpack_public_path__ + "static/media/Arrow_Clicked_Unfold.25459a0a85fa7cdd84ddc559078cda28.svg";
export { ForwardRef as ReactComponent };